import {
  fetchAuthSession,
  signOut,
  updateUserAttribute,
} from "aws-amplify/auth";
import { AppPath } from "./constants";
import runtimeConfig from "runtimeConfig";
import { setLoginNotice } from "utils/loginNotice";
import CryptoJS from "crypto-js";
import axios from "axios";
import { JA } from "./strings.ja";

export const handleSectionNavigation = (id) => {
  const element = document.getElementById(id);
  const offset = 45;
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element?.getBoundingClientRect().top ?? 0;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
};

export async function updateLastLoginTime(value) {
  const attributeKey = "birthdate";

  try {
    const { nextStep } = await updateUserAttribute({
      userAttribute: {
        attributeKey,
        value,
      },
    });
    if (nextStep.updateAttributeStep === "DONE") {
      console.log("attribute was successfully updated.");
    } else {
      console.log("attribute was not updated.");
    }
  } catch (error) {
    console.log(error);
  }
}

export async function handleEnterVms(tenant, locationName = "") {
  const buildPayload = async () => {
    const { key, client_id, refreshToken } = await handleToken();
    const data = { token: key, rfToken: refreshToken, clientId: client_id };
    if (locationName) data.zoneName = locationName;
    return data;
  };

  const handoffUrl = getEndPoint("/api/create-handoff/", tenant);

  let response;
  try {
    response = await axios.post(handoffUrl, await buildPayload(), {
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    if (error.response?.status !== 401) throw error;
    // Refresh Cognito session and retry once
    response = await axios.post(handoffUrl, await buildPayload(), {
      headers: { "Content-Type": "application/json" },
    });
  }

  const { handoffId } = response.data;
  window.open(`${getEndPoint("/", tenant)}?handoffId=${handoffId}`);
}

export async function handleToken() {
  try {
    const { tokens } = await fetchAuthSession();
    const accessTokenObj = tokens?.accessToken;
    const key = accessTokenObj.toString();
    const { client_id } = accessTokenObj.payload;
    const refreshToken = getRefreshTokenFromLocalStorage(client_id);
    const apiName = "AdminQueries";

    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    };

    return { apiName, headers, key, client_id, refreshToken };
  } catch (error) {
    await endExpiredSession();
    return;
  }
}

// The Cognito session is gone (or the API refuses it): tell the user and start
// again at the login screen.
export async function endExpiredSession(notice = JA.auth.sessionTimeout) {
  setLoginNotice(notice);
  await signOut();
  localStorage.clear();
  window.location.href = AppPath.Login;
}

function getRefreshTokenFromLocalStorage(clientId) {
  const lastUserKey = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`;
  const lastUser = localStorage.getItem(lastUserKey);
  const refreshTokenKey = `CognitoIdentityServiceProvider.${clientId}.${lastUser}.refreshToken`;
  return localStorage.getItem(refreshTokenKey);
}

export function formatDateJsFromTimeStamp(timeStamp) {
  // convert timestamp to Int
  const timeStampInt = parseInt(timeStamp) * 1000;
  const date = new Date(timeStampInt);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hour = date.getHours().toString().padStart(2, "0");
  const minute = date.getMinutes().toString().padStart(2, "0");
  const second = date.getSeconds().toString().padStart(2, "0");

  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
}

export const cutLongTextJs = (text, maxLength = 20) => {
  if (text && text?.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};

export function generatePassword() {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=";
  let password = "";
  while (true) {
    password = "";
    for (let i = 0; i < Math.floor(Math.random() * 8) + 8; i++) {
      password += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    if (
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /[0-9]/.test(password) &&
      /[^A-Za-z0-9]/.test(password)
    ) {
      break;
    }
  }
  return password;
}

export function checkPasswordRequirements(password) {
  if (password.length < 8 || password.length > 16) {
    return false;
  }
  if (!/[A-Z]/.test(password)) {
    return false;
  }
  if (!/[a-z]/.test(password)) {
    return false;
  }
  if (!/[0-9]/.test(password)) {
    return false;
  }
  if (!/[^A-Za-z0-9]/.test(password)) {
    return false;
  }
  return true;
}

export function hasPermission(loginData, role, type) {
  return loginData?.role === role && loginData?.type === type;
}

export const getProtocol = () => {
  return window.location.hostname === "localhost" ? "http://" : "https://";
};

export const getEndPoint = (endPoint = "", tenantID = "") => {
  const domain = runtimeConfig().vmsDomain || "";
  return `https://${tenantID}.${domain}${endPoint}`;
  // return `http://${tenantID}.localhost:8000${endPoint}`;
};

export const getTimeZone = () => {
  const date = new Date();
  const timezoneOffset = date.getTimezoneOffset();
  return timezoneOffset / -60;
};

export function formatDatetimeWithZone(isoString) {
  let date = new Date(isoString);
  let timezone = getTimeZone();

  // Convert date to the desired timezone
  let localDate = new Date(date.getTime() + timezone * 60 * 60 * 1000); // timezone offset in milliseconds

  // Return the local date formatted as ISO string
  return localDate.toISOString();
}
export function formatDatetimeCreateAt(isoString) {
  let date = new Date(isoString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hour = date.getHours().toString().padStart(2, "0");
  const minute = date.getMinutes().toString().padStart(2, "0");
  const second = date.getSeconds().toString().padStart(2, "0");

  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
}

export class EncryptDecryptPasswordHandler {
  constructor(secret = "mimamoriaisecretkey") {
    this.secret = secret;
  }

  // Create 32-byte AES key
  getKey() {
    return CryptoJS.SHA256(this.secret);
  }

  // ✅ Encrypt
  encrypt(text) {
    // if text is null or undefined, return null
    if (text === null || text === undefined) {
      return null;
    }

    // Use deterministic IV based on text hash for same output
    const textHash = CryptoJS.SHA256(text + this.secret);
    const iv = CryptoJS.lib.WordArray.create(textHash.words.slice(0, 4)); // First 16 bytes
    
    const key = this.getKey();
    
    const encrypted = CryptoJS.AES.encrypt(text, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Combine IV and encrypted data, then encode to base64
    const combined = iv.concat(encrypted.ciphertext);
    return CryptoJS.enc.Base64.stringify(combined);
  }

  // ✅ Decrypt
  decrypt(encData) {
    if (encData === null || encData === undefined) {
      return null;
    }

    // Decode base64 to get combined IV and ciphertext
    const combined = CryptoJS.enc.Base64.parse(encData);
    
    // Extract IV (first 16 bytes) and ciphertext
    const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(combined.words.slice(4));
    
    const key = this.getKey();
    
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ciphertext }, 
      key, 
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
// "ID - Name" label used in the list tables. Falls back to the bare ID when the
// name isn't known — v2 can't always resolve a parent group's name, since the
// @auth rules don't let every caller read the parent's GroupInfo row.
export const formatIdName = (id, name) =>
  name ? `${id} - ${name}` : id || "";
